export default "__VITE_ASSET__OfqnHY7c__"